import styled from "styled-components";

export const Footers = styled.footer`
 height:250px;
 width:auto;
 display:flex;
 flex-direction:column;
 align-items:center;
 justify-content:center;
 background-color:#dfdfdf;
`;

